import { OnInit, OnDestroy, ChangeDetectionStrategy, Component, Injector } from "@angular/core";
import { combineLatest, EMPTY, Observable, Subject } from "rxjs";
import { switchMap, map, catchError, shareReplay, startWith, takeUntil } from "rxjs/operators";
import { ApexChart, ApexLegend, ApexNonAxisChartSeries, ApexPlotOptions } from "ng-apexcharts";
import { GetPrescriptionsStatsRequest, PrescriptionApi } from "../api/proxies";
import { StatsService } from "../services/stats.service";
import { AppComponentBase } from "@shared/app-component-base";

export type PieChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    labels: string[];
    legend: ApexLegend;
    plotOptions: ApexPlotOptions;
};

@Component({
    selector: "documents-summary",
    templateUrl: "./summary.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentsSummaryComponent extends AppComponentBase implements OnInit, OnDestroy {
    private _destroy$ = new Subject<void>();

    loading$!: Observable<boolean>;

    prescriptionChartOptions$!: Observable<Partial<PieChartOptions>>;

    constructor(
        injector: Injector,
        private statsService: StatsService,
        private prescriptionApi: PrescriptionApi
    ) {
        super(injector)
    }

    ngOnInit(): void {
        const stream$ = combineLatest([this.statsService.period$, this.statsService._tenant$]).pipe(
            takeUntil(this._destroy$),
            switchMap(([period, tenant]) => {
                const req = new GetPrescriptionsStatsRequest();
                req.start = period.periodStart;
                req.end = period.periodEnd;
                req.tenantId = tenant?.id;
                return this.prescriptionApi.stats(req).pipe(
                    catchError(() => {
                        this.message.error("Falha ao carregar Prescrições");
                        return EMPTY;
                    })
                );
            }),
            shareReplay({ bufferSize: 1, refCount: true })
        );

        this.loading$ = stream$.pipe(
            map(() => false),
            startWith(true),
            catchError(() => EMPTY)
        );

        this.prescriptionChartOptions$ = stream$.pipe(
            map(stats => ({
                series: [stats.smart, stats.standard],
                chart: { type: 'donut', animations: { enabled: false } },
                labels: ['Inteligentes', 'Padrão'],
                legend: { position: 'bottom', horizontalAlign: 'center' },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '60%',
                            labels: {
                                show: true,
                                total: { showAlways: false, show: true, color: '#000000' }
                            }
                        }
                    }
                }
            } as Partial<PieChartOptions>))
        );
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
